import React from 'react';
import { Link } from 'react-router-dom';
import { useAgentPlatformAccess } from '../../hooks/useAgentPlatformAccess';
import { Button } from '../UI/Button';

type Props = {
  feature: 'platform' | 'agents' | 'tools' | 'flows';
  children: React.ReactNode;
};

export const AgentPlatformFeatureGate: React.FC<Props> = ({ feature, children }) => {
  const access = useAgentPlatformAccess();

  if (access.loading) {
    return (
      <div className="flex items-center justify-center py-16 text-gray-500">Carregando licença…</div>
    );
  }

  const allowed =
    feature === 'platform'
      ? access.hasPlatform
      : feature === 'agents'
        ? access.hasAgents
        : feature === 'tools'
          ? access.hasTools
          : access.hasFlows;

  if (allowed) {
    return <>{children}</>;
  }

  return (
    <div className="max-w-lg mx-auto mt-16 p-8 bg-white rounded-lg shadow border border-gray-200 text-center">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">Recurso não licenciado</h2>
      <p className="text-gray-600 mb-6">
        Este módulo não está habilitado no plano do tenant. Entre em contato com a operadora para
        ativar a Plataforma Agêntica.
      </p>
      <Link to="/admin/control-panel">
        <Button variant="secondary">Voltar ao painel</Button>
      </Link>
    </div>
  );
};
